import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";

const ErrorPopup = ({
  open,
  setOpen,
  message,
  title,
  handleUpdate,
  buttonTitle,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    maxHeight: "40vh",
    overflowY: "auto",
    width: { xs: "90%", sm: "400px" },
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={style}>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: 600, color: "error.main" }}
        >
          {title}
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </Typography>

        <Button
          variant="contained"
          color="error"
          fullWidth
          onClick={handleUpdate}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            borderRadius: 2,
            py: 1.2,
          }}
        >
          {buttonTitle}
        </Button>
      </Box>
    </Modal>
  );
};

export default ErrorPopup;
